import { Link } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";

const JeinarSection = () => {
  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const photoReveal = useScrollReveal({ threshold: 0.15 });
  const textReveal = useScrollReveal({ threshold: 0.15 });
  const ctaReveal = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="jeinar-home" className="py-24 sm:py-36 px-6 bg-[#C5A059]/20">
      <div className="max-w-2xl mx-auto text-center space-y-12">

        {/* Header */}
        <div
          ref={headerReveal.ref}
          className={`space-y-4 scroll-reveal-slow ${headerReveal.isVisible ? "visible" : ""}`}
        >
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
            La fondatrice
          </p>
          <h3 className="font-serif text-2xl sm:text-3xl text-[#F3E5CF]">
            Jeinar
          </h3>
          <p className="font-serif text-sm text-[#F3E5CF]/60 italic">
            Celle qui tient l'espace.
          </p>
        </div>

        {/* Photo */}
        <div
          ref={photoReveal.ref}
          className={`flex justify-center scroll-reveal ${photoReveal.isVisible ? "visible" : ""}`}
        >
          <div className="w-40 h-40 rounded-full overflow-hidden border-2 border-[#C5A059]">
            <img
              src="https://customer-assets.emergentagent.com/job_e1c789c5-29a6-44f5-835a-061fa2b0d68d/artifacts/4et8qr3p_C5480FAD-C83F-430F-A87F-24861F3BE502.jpeg"
              alt="Jeinar"
              className="w-full h-full object-cover"
              style={{ objectPosition: '50% 15%' }}
            />
          </div>
        </div>

        {/* Texte épuré */}
        <div
          ref={textReveal.ref}
          className={`space-y-4 font-serif text-base sm:text-lg text-[#F3E5CF]/70 leading-[2.4] scroll-reveal ${textReveal.isVisible ? "visible" : ""}`}
        >
          <p className="text-[#F3E5CF]/50 italic text-sm sm:text-base">Rien ici n'est théorique.</p>
          <div className="h-2" />
          <p>Ce qui a été traversé</p>
          <p className="italic text-[#F3E5CF]/50">est devenu transmission.</p>
          <div className="w-8 h-[1px] bg-[#C5A059]/30 mx-auto my-2" />
          <p>Ce qui a été vécu</p>
          <p className="italic text-[#F3E5CF]/50">est devenu chemin.</p>
        </div>

        {/* CTA */}
        <div
          ref={ctaReveal.ref}
          className={`pt-4 scroll-reveal ${ctaReveal.isVisible ? "visible" : ""}`}
        >
          <Link
            to="/story/jeinar"
            className="inline-flex items-center justify-center px-10 py-4 rounded-full bg-[#C5A059] text-[#3F2A24] text-[0.65rem] tracking-[0.2em] uppercase font-medium hover:bg-[#3F2A24] hover:text-[#F3E5CF] transition-all duration-500 min-h-[48px]"
            data-testid="home-discover-jeinar-btn"
          >
            Je rencontre Jeinar
          </Link>
        </div>
      </div>
    </section>
  );
};

/* ═══ CONSERVATION TEMPORAIRE — ancien JeinarSection ═══
 *
 * Titre: "Qui est Jeinar ?"
 * Sous-titre: "Celle qui tient l'espace" + "une source vivante."
 * Bio longue:
 *   "L'âme qui porte COCON s'appelle Jeinar."
 *   "Une femme qui a traversé deux vies :"
 *   "celle de la performance,"
 *   "et celle de la vérité."
 *   "La première l'a menée à l'épuisement."
 *   "La seconde a ouvert un chemin vers la lumière."
 *   "Sa transmission est née du réel :"
 *   "de l'effondrement,"
 *   "du silence,"
 *   "et du courage de recommencer."
 * CTA: "Je découvre le récit de Jeinar"
 *
 * ═══ FIN CONSERVATION TEMPORAIRE ═══ */

export default JeinarSection;
